function Main({ children }) {
  return <main className="map-canvas">{children}</main>;
}

export default Main;
